import React from 'react';
import { Radio } from 'tea-component';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import { IBasicFormItemProps } from '../../type';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { getShowLabel } from '../../utils';

export default function RadioGroup(props: IBasicFormItemProps) {
  const { options = [], value, field, onChange } = props;
  // console.log('radio', props);
  const { formatMessage } = useIntlExtend();

  return (
    <>
      <Radio.Group
        className="dbi-radio-group"
        value={value}
        onChange={(value) => onChange(field, value)}
      >
        {options?.length > 0 &&
          options?.map((item) => (
            <Radio name={item?.value} key={item?.value} style={{ display: item.isShow ? 'inline-block' : 'none' }}>
              {getShowLabel(item, formatMessage)}
              {getShowLabel(item, formatMessage, 'msg') && <TipContext tipText={getShowLabel(item, formatMessage, 'msg')} className="checkbox-group-tip" />}
            </Radio>
          ))}
        {getShowLabel(props, formatMessage, 'msg') && (
          <TipContext
            className="dbi-tip-icon"
            AWidth={381}
            tipText={getShowLabel(props, formatMessage, 'msg')}
          />
        )}
      </Radio.Group>
    </>
  );
}
